module.exports = __webpack_public_path__ + "img/401.436c572b.png";